import { useMemo } from 'react'
import InsightViewOption, { InsightViewOptionStrings } from 'enums/InsightViewOption'
import {
  generateEmojiInsightStrategy,
  generateHashtagsInsightStrategy,
  generateTermsInsightStrategy,
  generateThingsInsightStrategy,
  generateBrandsInsightStrategy,
  generatePeopleInsightStrategy
} from 'utils/insightModal/strategy/searchFilterComposing'

const useSearchFilterComposingStrategy = (viewOption: InsightViewOptionStrings) => {
  const searchFilterComposingStrategy = useMemo(() => {
    switch (viewOption) {
      case InsightViewOption.TERMS:
        return generateTermsInsightStrategy()
      case InsightViewOption.HASHTAGS:
        return generateHashtagsInsightStrategy()
      case InsightViewOption.EMOJIS_EMOJI:
      case InsightViewOption.EMOJIS_EMOTION:
      case InsightViewOption.EMOJIS_GROUP:
        return generateEmojiInsightStrategy()
      case InsightViewOption.THINGS:
        return generateThingsInsightStrategy()
      case InsightViewOption.BRANDS:
        return generateBrandsInsightStrategy()
      case InsightViewOption.PEOPLE:
        return generatePeopleInsightStrategy()
      default:
        throw new Error(`Unsupported view option: ${viewOption}`)
    }
  }, [viewOption])

  return searchFilterComposingStrategy
}

export default useSearchFilterComposingStrategy
